import script from "./cpt-realtime-position.vue?vue&type=script&setup=true&lang=js"
export * from "./cpt-realtime-position.vue?vue&type=script&setup=true&lang=js"

import "./cpt-realtime-position.vue?vue&type=style&index=0&id=35832963&lang=css"
import "./cpt-realtime-position.vue?vue&type=style&index=1&id=35832963&lang=css"

const __exports__ = script;

export default __exports__